import { render } from "./MdFab.vue?vue&type=template&id=1949613e&scoped=true&ts=true"
import script from "./MdFab.vue?vue&type=script&lang=ts"
export * from "./MdFab.vue?vue&type=script&lang=ts"

import "./MdFab.vue?vue&type=style&index=0&id=1949613e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1949613e"]])

export default __exports__